<ng-container *ngIf="!loadFlag">
  <payarc-page-header [title]="heading" [subtitle]="!idPresent ? 'We need to learn more about you and your business before you can process payments on Payarc.' : ''"></payarc-page-header>

  <payarc-inline-alert variant="bad" *ngIf="topErrorMessage">
    <div *ngFor="let msg of keys1">{{ msg }}</div>
  </payarc-inline-alert>
  <payarc-inline-alert variant="bad" *ngIf="!topErrorMessage && errorMsg">{{ errorMsg }}</payarc-inline-alert>

  <form #account="ngForm">
    <payarc-section-card heading="Where are you based?">
      <div class="maa-grid">
        <payarc-form-field label="Country" [required]="true" controlId="country">
          <select class="pa-input" id="country" name="country" #country="ngModel" required [(ngModel)]="merchantActivation.country_code">
            <option *ngFor="let country of countries" [value]="country.key">{{ country.name }}</option>
          </select>
        </payarc-form-field>
      </div>
    </payarc-section-card>

    <payarc-section-card heading="Account details">
      <div class="maa-grid">
        <payarc-form-field label="Your business type" [required]="true" controlId="account_details">
          <select class="pa-input" id="account_details" name="account_details" #account_details="ngModel" required [(ngModel)]="merchantActivation.business_type">
            <option value="Corporation">Corporation</option>
            <option value="Individual">Individual</option>
            <option value="LLC">LLC</option>
            <option value="Non-profit">Non-profit</option>
            <option value="Partnership">Partnership</option>
          </select>
        </payarc-form-field>
        <payarc-form-field label="EIN (Tax ID)" [required]="true" controlId="ein_tax">
          <input type="text" class="pa-input" id="ein_tax" name="ein_tax" #ein_tax="ngModel" required
                 [(ngModel)]="merchantActivation.tax_id" pattern="^[1-9]\d?-\d{7}$"
                 placeholder="12-3456789" (keypress)="EIN($event)" maxlength="10">
          <p class="pa-ff__hint">If you use your social security number for business tax purposes, you can use that instead. If you don't have an EIN yet, you can apply for one online.</p>
        </payarc-form-field>
      </div>

      <p class="maa-label">Business address</p>
      <div class="maa-grid maa-grid--address">
        <payarc-form-field label="Address" [required]="true" controlId="business_address">
          <input type="text" class="pa-input" id="business_address" name="business_address" #business_address="ngModel" required
                 [(ngModel)]="merchantActivation.address" placeholder="Address" maxlength="200">
        </payarc-form-field>
        <payarc-form-field label="City" [required]="true" controlId="city1">
          <input type="text" class="pa-input" id="city1" name="city1" #city1="ngModel" required
                 [(ngModel)]="merchantActivation.city" placeholder="City" maxlength="200">
        </payarc-form-field>
        <payarc-form-field label="State" [required]="true" controlId="state">
          <select class="pa-input" id="state" name="city" #city="ngModel" required [(ngModel)]="merchantActivation.state">
            <option [value]="null">Choose your state</option>
            <option *ngFor="let state of states" [value]="state.name">{{ state.name }}</option>
          </select>
        </payarc-form-field>
        <payarc-form-field label="Zip" [required]="true" controlId="zip">
          <input type="text" class="pa-input" id="zip" name="zip" #zip="ngModel" required maxlength="5"
                 (keypress)="_keyPress($event)" [(ngModel)]="merchantActivation.zip" placeholder="Zip">
        </payarc-form-field>
      </div>

      <div class="maa-grid">
        <payarc-form-field label="Website URL" [required]="true" controlId="website_url">
          <input type="text" class="pa-input" id="website_url" name="website_url" #websiteUrl="ngModel" required pattern="https?://.+"
                 [(ngModel)]="merchantActivation.website_url" placeholder="Your website">
        </payarc-form-field>
        <payarc-form-field label="Business description" [required]="true" controlId="productdesc">
          <input type="text" class="pa-input" id="productdesc" name="productdesc" #product_desc="ngModel" required
                 [(ngModel)]="merchantActivation.product_desc">
        </payarc-form-field>
      </div>
    </payarc-section-card>

    <payarc-section-card heading="You, the individual or sole proprietor">
      <p class="maa-label">Legal name</p>
      <div class="maa-grid">
        <payarc-form-field label="First name" [required]="true" controlId="legal_name_first">
          <input type="text" class="pa-input" id="legal_name_first" name="legal_name_first" #legal_name="ngModel" required
                 [(ngModel)]="merchantActivation.first_name" placeholder="First name">
        </payarc-form-field>
        <payarc-form-field label="Last name" [required]="true" controlId="legal_name_last">
          <input type="text" class="pa-input" id="legal_name_last" name="legal_name" #legal_name2="ngModel" required
                 [(ngModel)]="merchantActivation.last_name" placeholder="Last name">
        </payarc-form-field>
      </div>

      <div class="maa-grid">
        <payarc-form-field label="Date of birth" [required]="true" controlId="dob">
          <div class="maa-date">
            <input type="text" class="pa-input" id="dob" #dob="ngModel" required [matDatepicker]="dp" name="dob" [max]="maxDate" [(ngModel)]="merchantActivation.dob">
            <mat-datepicker #dp></mat-datepicker>
            <button class="pa-btn pa-btn--secondary" (click)="dp.open()" type="button">
              <img class="maa-calendar-icon" src="../../../../assets/images/calendar-min.png" alt="">
            </button>
          </div>
        </payarc-form-field>
        <payarc-form-field label="Last four digits of your social security number" [required]="true" hint="We use the last four digits to verify your identity." controlId="social_security">
          <div class="maa-ssn">
            <span class="maa-ssn__mask">••• – •• –</span>
            <input type="text" class="pa-input" id="social_security" name="social_security" #social_security="ngModel" required
                   [(ngModel)]="merchantActivation.ssnlast4" (keypress)="_keyPress($event)" placeholder="9999" maxlength="4">
          </div>
        </payarc-form-field>
      </div>
    </payarc-section-card>

    <payarc-section-card heading="Credit card statement details" sub="Your business name and phone number will appear on your customers' credit card statements. Don't worry, you can change this information later.">
      <div class="maa-grid">
        <payarc-form-field label="Business name" [required]="true" hint="The name for your business that your customers will recognize. This may be the legal entity name, or a doing business as (DBA), assumed business name, trade name, or trade style." controlId="business_name">
          <input type="text" class="pa-input" id="business_name" name="business_name" #business_name="ngModel" required
                 [(ngModel)]="merchantActivation.business_name" placeholder="My company">
        </payarc-form-field>
        <payarc-form-field label="Phone" [required]="true" controlId="phone">
          <div class="maa-phone">
            <span class="maa-phone__code">+1</span>
            <input type="text" class="pa-input" id="phone" name="phone" #phone="ngModel" required maxlength="10" pattern="^[0-9]*$"
                   (keypress)="_keyPress($event)" [(ngModel)]="merchantActivation.phone_number">
          </div>
        </payarc-form-field>
      </div>
    </payarc-section-card>

    <payarc-section-card heading="Bank details" sub="You can accept USD. Your bank account must be a checking account.">
      <div class="maa-grid">
        <payarc-form-field label="Routing number" [required]="true" controlId="routing_number">
          <input type="text" class="pa-input" id="routing_number" name="routing_number" #routing_number="ngModel" required maxlength="9"
                 (keypress)="_keyPress($event)" pattern="^[0-9]*$" [(ngModel)]="merchantActivation.routing_number" placeholder="111000000">
        </payarc-form-field>
        <payarc-form-field label="Account number" [required]="true" controlId="account_number">
          <input type="password" class="pa-input" id="account_number" name="account_number" #account_number="ngModel" required
                 (keypress)="_keyPress($event)" [(ngModel)]="merchantActivation.account_number">
        </payarc-form-field>
        <payarc-form-field label="Confirm account number" [required]="true" controlId="confirm_account_number"
          [error]="(confirm_account_number.touched || confirm_account_number.dirty) && (merchantActivation.account_number !== accountNumberCheck) ? 'Account numbers don\'t match. Try again.' : ''">
          <input type="password" class="pa-input" id="confirm_account_number" name="confirm_account_number" #confirm_account_number="ngModel" required
                 (keypress)="_keyPress($event)" [(ngModel)]="accountNumberCheck">
        </payarc-form-field>
      </div>
    </payarc-section-card>

    <div class="maa-footer">
      <p class="maa-agree">By activating your account, you agree to our services agreement. <strong>Payarc</strong></p>
      <app-loading-button (buttonClick)="activationPostCall()" [disable]="account.invalid || merchantActivation.account_number !== accountNumberCheck" [loadFlag]="loadFlag" [buttonText]="'Activate account'"></app-loading-button>
    </div>
  </form>
</ng-container>
